
<div class="mainWrap">
    <div class="bgImageWrap">
        <img src="../../../assets/images/mainHome.png">
    </div>
    <div class="bgImageMobileWrap">
        <img src="../../../../assets/images/homeMobileBg.png">
    </div>

 
    <div class="overLay">
        <div class="textWrap">
            <div class="titleWrap ">
                <span class="typed-element"></span>
            </div>
            <div class="subTitleWrap">
                Execution does matter, not just the idea alone. 
                <span style="width: 100%; float: left;"> Quality standards and unique architectures is what makes us different.</span>
            </div>
            <div class="knowMoreWrap">
                <div class="buttonWrap">
                    <button (click)="onKnowMore()">
                        KNOW MORE
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>